import { get } from "../../../shared/data";

export const getTaskMetrics = (upcs) => {
    return get("/admin/dashboard/counts", { defaultReturn: {} });
};
